export const CONTACTS_ENDPOINT_FV_ID_PARAM_NAME = 'filteredViewId' as const

export type SegmentsTableColumns = 'name' | 'count' | 'updatedAt'

export enum SegmentSaveAsModalFormFields {
  name = 'name',
  icon = 'icon',
}

export type SegmentSaveAsModalFormSchema = {
  [SegmentSaveAsModalFormFields.name]: string
  [SegmentSaveAsModalFormFields.icon]: string
}

export enum SegmentCreateModalFormFields {
  name = 'name',
  openCreateInNewTab = 'openCreateInNewTab',
}

export type SegmentCreateModalFormSchema = {
  [SegmentCreateModalFormFields.name]: string
  [SegmentCreateModalFormFields.openCreateInNewTab]: boolean
}

export enum SegmentRenameModalFormFields {
  name = 'name',
}

export type SegmentRenameModalFormSchema = {
  [SegmentRenameModalFormFields.name]: string
}
